export const protobufPackage = "snapchat.cdp.media";
export enum SnapSource {
    UNKNOWN = 0,
    FEED = 1,
    FEED_SNAP_REPLY = 3,
    IN_CHAT = 5,
    CAMERA = 10,
    CAMERA_ROLL = 13,
    GALLERY = 14,
    PROFILE = 33,
    PALMTREE = 66,
    UNRECOGNIZED = -1
}
